module.exports = __webpack_public_path__ + "static/media/video.9ae6168b.svg";